<template>
  <a-spin :spinning="confirmLoading">
    <DevBpbjInfoList pageType="select" ref="infoList" />
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import DevBpbjInfoList from '../DevBpbjInfoList.vue'
  export default {
    name: 'DevBpbjWarehousingListForm',
    components: {
      DevBpbjInfoList
    },
    props: {
      // 表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: '/spareparts/devBpbjWarehousingList/add',
          edit: '/spareparts/devBpbjWarehousingList/edit',
          queryById: '/spareparts/devBpbjWarehousingList/queryById'
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      }
    },
    created () {
      // 备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model))
    },
    methods: {
      add () {
        this.edit(this.modelDefault)
      },
      edit (record) {
        this.model = Object.assign({}, record)
        this.visible = true
      },
      submitForm () {
        const that = this
        const { selectionRows } = that.$refs.infoList
        that.$emit('ok', selectionRows)
        // 触发表单验证
        // this.$refs.form.validate(valid => {
        //   if (valid) {
        //     that.confirmLoading = true
        //     let httpurl = ''
        //     let method = ''
        //     if (!this.model.id) {
        //       httpurl += this.url.add
        //       method = 'post'
        //     } else {
        //       httpurl += this.url.edit
        //       method = 'put'
        //     }
        //     httpAction(httpurl, this.model, method).then((res) => {
        //       if (res.success) {
        //         that.$message.success(res.message)
        //         that.$emit('ok')
        //       } else {
        //         that.$message.warning(res.message)
        //       }
        //     }).finally(() => {
        //       that.confirmLoading = false
        //     })
        //   }
        // })
      }
    }
  }
</script>
